export enum Screen {
  SCAN_RLPN_RASN,
  SCAN_UNIT,
  GRADING,
  REWORK,
  SCAN_TOTE,
  CGRADE_COMPLETION,
}
